// extracted by mini-css-extract-plugin
export var container = "image-wall-module--container--4Pmg6";
export var image = "image-wall-module--image--xVEhZ";